module.exports = __webpack_public_path__ + "img/xianghe1.0a77702e.png";